
export enum ActionPlanType {
    training = 'training',
    eLearning = 'eLearning',
    hiring = 'hiring',
    purchasing = 'purchasing',
    updatingSop = 'updatingSop',
    other = 'other',
}
